import {DataItem} from 'vis-timeline/esnext';
import {DataSet} from 'vis-data/esnext';
import moment from 'moment';
import {MACHINES} from '@/views/timeline/services/machines';

let uniqueId = 10000;

const tooltipPairTemplate: string = '<div class="ametras-tooltip"><span>%LEFT%</span><span>%RIGHT%</span></div>';

const options = [{
    customer: 'Nagel',
    style: 'background-color: #ee0033',
}, {
    customer: 'Liebherr',
    style: 'background-color: #55dd66',
}, {
    customer: 'Liebherr',
    style: 'background-color: #ffffbb',
}, {
    customer: 'Miele',
    style: 'background-color: #73B2D9',
}, {
    customer: 'Caterpillar',
    style: 'background-color: #ffcc44',
}, {
    customer: 'Komatsu',
    style: 'background-color: #FF6347',
}];

const ORDERS = new DataSet<DataItem>();

for (const machine of MACHINES) {
    const machineId = machine.id;
    for (let i = -99; i < 99; i++) {

        const anyMoment = moment().day(i);

        const isSaturday = anyMoment.isoWeekday() === 6;
        const isSunday = anyMoment.isoWeekday() === 7;
        if (isSaturday || isSunday) {
            continue;
        }
        const nextIndex = i + Math.floor(Math.random() * 10);
        const anyMomentInFuture = moment().day(nextIndex);
        i = nextIndex + 2;

        const option = options[Math.floor(Math.random() * options.length)];

        const start = anyMoment.hours(0).minutes(0).seconds(0);
        const ende = anyMomentInFuture.hours(23).minutes(59).seconds(0);
        const newOrder: DataItem = {
            id: ++uniqueId,
            content: uniqueId + '',
            title: tooltipPairTemplate.replace('%LEFT%', 'Kunde').replace('%RIGHT%', '17162').concat(
                tooltipPairTemplate.replace('%LEFT%', 'Name').replace('%RIGHT%', option.customer)).concat(
                tooltipPairTemplate.replace('%LEFT%', 'Auftrag').replace('%RIGHT%', uniqueId + '')).concat(
                tooltipPairTemplate.replace('%LEFT%', 'Masch.Nr').replace('%RIGHT%', String(machine.content))).concat(
                tooltipPairTemplate.replace('%LEFT%', 'Beginn').replace('%RIGHT%', start.format('DD.MM.YYYY'))).concat(
                tooltipPairTemplate.replace('%LEFT%', 'Ende').replace('%RIGHT%',  ende.format('DD.MM.YYYY'))
            ),
            style: option.style,
            start: start.toDate(),
            end: ende.toDate(),
            group: machineId,
            className: 'ametras-timeline__item ametras-timeline__item--machines'
        };
        ORDERS.add(newOrder);
    }
}
export {ORDERS};
